<template>
  <div>
    <resource-table
      v-bind="resourceData"
      :findFilter="{ where: { personid: personId } }"
      :table-headers="tableHeaders"
      ref="resourceList"
    >
      <template #newButton>
        <edit-resource-button
          v-bind="resourceData"
          :resource="{ personid: personId }"
          create-new
          @save="$refs.resourceList.loadResources()"
        >
          <template v-slot="formPropNew">
            <qualForm :qual="formPropNew.item" />
          </template>
        </edit-resource-button>
      </template>

      <template #item="{ item }">
        <tr>
          <td>
            <span v-if="item">{{ lookup("Quals", item.qualid) }}</span>
          </td>
          <td>
            <span v-if="item">{{
              lookup("Institutions", item.institutionid)
            }}</span>
          </td>
          <td>
            <span v-if="item">{{
              lookup(
                "Country",
                lookup("Institutions", item.institutionid, "countryid")
              ) || "Unknown"
            }}</span>
          </td>
          <td>
            <span v-if="item">{{
              lookup("ScopesOfPractice", item.scopeofpracticeid)
            }}</span>
          </td>
          <td>
            <span v-if="item">{{
              item.qualificationdate | formatDate("YYYY")
            }}</span>
          </td>
          <td>
            <edit-resource-button
              @save="$refs.resourceList.loadResources()"
              v-bind="resourceData"
              :resource="item"
            >
              <template v-slot:default="formPropsEdit">
                <qualForm :qual="formPropsEdit.item" />
              </template>
            </edit-resource-button>
            <delete-item-button
              :itemid="item.scopequalificationid"
              url="scopequalifications"
            />
          </td>
        </tr>
      </template>
    </resource-table>
  </div>
</template>

<script>
import resourceTable from "@/components/lib/resource_table/index";
import { mapGetters } from "vuex";
import qualForm from "./form";

export default {
  name: "QualificationsList",
  props: { personId: [Number, String] },
  components: {
    "resource-table": resourceTable,
    qualForm
  },
  data() {
    return {
      resourceData: {
        resourceName: "Scope Qualification",
        resourceUrl: "scopequalifications",
        resourceLabel: "Scope Qualifications",
        resourceIdField: "scopequalificationid"
      },
      tableHeaders: [
        {
          text: "Qualification",
          value: "qualid",
          sortable: true,
          lookup: "QualificationTypes"
        },
        { text: "University", value: "institutionid", lookup: "Institutions" },
        { text: "Country", sortable: false },
        {
          text: "Scope Of Practice",
          value: "scopeofpracticeid",
          lookup: "ScopesOfPractice"
        },
        {
          text: "Qualification Year",
          value: "qualificationdate",
          customDisplay: (date, qual) => {
            return this.$moment(date).format("YYYY");
          }
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  }
};
</script>
